export const types = [
  {
    name: 'ACIS',
    filter: 'ACIS',
    path: 'acis_analysis'
  }, {
    name: 'CIRT',
    filter: 'CIRT',
    path: 'cirt_analysis'
  }, {
    name: 'STACR',
    filter: 'STACR',
    path: 'deal_analysis'
  }, {
    name: 'CAS',
    filter: 'CAS',
    path: 'deal_analysis'
  }, {
    name: 'ILN',
    filter: ['Radnor', 'Home', 'Bellemeade', 'Eagle', 'Oaktown', 'Triangle'],
    path: 'deal_analysis'
  }
];

export const typesNames = types.map(type => type.name);

export const filterTypes = names => types.filter(type => names.includes(type.name));

export const getFilters = names => filterTypes(names).map(type => type.filter).flat();

export const dealAllowed = (deal, filters) =>
  filters.some(filter => deal.toUpperCase().includes(filter.toUpperCase()));

export const filterDeals = (deals, filters) => {
  if (!Array.isArray(filters)) { filters = [filters]; }

  return deals.filter(item => dealAllowed(item.DealName, filters));
}

export const initDealList = names => {
  let obj = {};
  names.forEach(name => {
    obj[name] = [];
  });
  return obj;
}

export const getDealType = dealName => {
  return types.filter(type => dealName.startsWith(type.filter) || type.filter.includes("Bellemeade")).map(type => type.name)[0] || undefined;
}

export default types;
